export const DEFAULT_TIMEOUT = 15_000;
// Note: Timeouts for device related requests were increased to 1 minute, as they can take longer to respond
export const SYSTEMS_LIST_TIMEOUT = 60_000;
export const REPORT_TIMEOUT = 60_000;
export const TIMEOUT_ERROR_CODE = 'ECONNABORTED';
export const TIMEOUT_EXPORT_HISTORY = 60_000;
